<!-- flag留言墙 -->
<template>
<div class="module-hd moduleHd_08">
  <div class="module-title">
    <img :src="barrageData.amc_detail.column_title_img" alt="">
  </div>
  <div class="mhd-content">
    <img :src="barrageData.amc_detail.column_back_img" alt="" class="item-image">
    <div class="mhd-page">
      <div class="berrage-box">
        <div class="berrage-intro df ai-c">活动说明： 新的一年，新的开始，正适合立个flag，图个好彩头，说说您的2025年愿望、计划或目标吧！ 留言即可天天领红包（翼狐币），评论不少于10个字，红包奖品等你来领！</div>
        <div class="berrage-list ofh df ai-c">
          <vue-danmaku
            ref="danmaku"
            v-model="barrageList"
            use-slot
            loop
            :speeds="100"
            :debounce="200"
            :randomChannel="true"
            :isSuspend="true"
            :top="40"
            :right="80">
            <template v-slot:dm="{ index, danmu }">
              <div class="berrage-item df ai-c"
                :class="`berrage-item${randomInt(1, 2)}`">
                <img class="avatar" onerror="this.src='https://img12.yiihuu.com/60X60/upimg/avatar/default.jpg';this.onerror=null;" :src="danmu.img" alt=""
                :class="{ ml: danmu.info.length > 40 }"
                >
                <span class="txt txt1 df ai-c">{{ danmu.info.slice(0, 60) }}</span>
              </div>
            </template>
            <!-- <div></div> -->
          </vue-danmaku>
        </div>
        <div class="berrage-action df ai-c">
          <input type="text" class="berrage-input f1" minlength="10" maxlength="80" placeholder="快来说说您新的一年flag吧~" v-model="berrageTxt" />
          <div class="berrage-send-btn"
            @click="sendBerrage">
            <img :src="barrageData.amc_detail.pc_column_btn_img" alt="">
            <img :src="barrageData.amc_detail.pc_column_btn_hover" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- 中奖弹窗 -->
  <van-popup
    class="custom-dialog barrage-prize"
    v-if="prizeDialog"
    v-model="prizeDialog"
    get-container="body"
    :close-on-click-overlay="false"
    >
    <div class="barrage_prizeItem1"
      :class="{ 
        zoomer : prizeDialog,
        zoomerOut : prizeItem==2
      }"
    >
      <span class="barrage_close"
      @click="showPrizeDialog(false)"></span>
      <img src="@/assets/images/activity/barrage/barrage_prize.png">
      <a href="javascript:void(0);" class="barrage_prize_button"
        @click="switchPrizeItem(2)"></a>
    </div>
    <div class="barrage_prizeItem2"
      :class="{ zoomer:hasZoomerCls}"
    >
      <span class="barrage_close_btn"
      @click="showPrizeDialog(false)"
      ></span>
      <img :src="prizeImageSrc">
      <a href="javascript:void(0);" class="barrage_close_an"
      @click="showPrizeDialog(false)"></a>
    </div>
  </van-popup>

  <!-- 祝福语弹窗 -->
  <van-popup
    class="custom-dialog blessing-prize"
    v-model="blessingDialog"
    get-container="body"
    :close-on-click-overlay="false"
    @open="onDialogOpen">
    <div class="layer_w1">
      <span class="blessing_close"
      @click="showBlessingDialog(false)"
      ></span>
      <!-- 祝福图片，随机展示  -->
      <img :src="curBlessingImage" class="blessing_img">
      <a href="javascript:void(0);" class="blessing_button"
      @click="showBlessingDialog(false)"
      ></a>
    </div>
  </van-popup>

  <!-- 鼠标跟随动画 -->
  <div id="sketchWrap">
    <img src="@/assets/images/activity/barrage/bubble.png" alt="" class="bubble-img" style="display: none;">
  </div>
</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import vueDanmaku from 'vue-danmaku'
import { bubbleSketch } from '@/assets/js/sketch/particles.js';

import { ajaxActiveMsg } from '@/api/activity/';

export default {
  name: "Barrage",
  props: {
    activityId: {
      type: [Number,String],
      default() {
        return 0
      }
    },
    barrageData: {
      type: Object,
      default() {
        return {

        }
      }
    },
  },
  components: {
    vueDanmaku,
  },
  data(){
    return {
      barrageList: [],//弹幕数据
      berrageTxt:'',
      prizeDialog:false,
      prizeItem:1,//1:开奖前界面，2:开奖后界面
      barragePrize:1,//奖品标识：红包奖品:1-6,积分奖品:7-12,其它：祝福标签，6标签随机展示
      hasZoomerCls:false,
      blessingDialog:false,
      curBlessingImage: require(`@/assets/images/activity/barrage/blessing_prize_1.png`),

    }
  },
  watch: {
    'barrageData': {
      handler(val, old) {
        // console.log(val, old)
      }
    },
    'prizeItem': {
      handler(val, old) {
        if(val==2){
          setTimeout(() => {
            this.hasZoomerCls=true
          }, 600)
        }else{
          this.hasZoomerCls = false
        }
      }
    },
    // 'blessingDialog': {
    //   handler(val, old) {
    //     this.onDialogOpen()
    //   }
    // }
  },
  computed: {
    ...mapGetters(['token','nick','MemberInfo']),
    prizeImageSrc(){
      let imgName= this.addZero(this.barragePrize)
      return require(`@/assets/images/activity/barrage/barrage_prize_${imgName}.png`)
    },
  },
  created() {
    this.getInitData()

    this.$nextTick(()=>{
      bubbleSketch.init()
    })
  },
  methods: {
    async getInitData(){
      let params={
        active_id:this.activityId,
        type: 1
      }
      let res= await ajaxActiveMsg(params)
      let {code,data,msg, }=res.data
      if(code==0){
       this.barrageList= data
      }
    },
    showPrizeDialog(bol){
      if(bol===false){
        this.prizeDialog = false

        this.switchPrizeItem(1)
      }else{
        this.prizeDialog=true
      }
    },
    showBlessingDialog(bol) {
      if (bol === false) {
        this.blessingDialog = false
        this.curBlessingImage = ''
      } else {
        this.blessingDialog = true
      }
    },
    onDialogOpen(){
      // 6祝福图片，随机展示
      let imgName = this.randomInt(1,6)
      this.curBlessingImage= require(`@/assets/images/activity/barrage/blessing_prize_${imgName}.png`)
    },
    switchPrizeItem(num){
      this.prizeItem = num
    },
    async sendBerrage(){
      if(!this.token){
        this.$login.show()
        return
      }
      if(this.berrageTxt.length<10){
        this.$layer.msg('评论不少于10个字哦')
        return
      }

      let params={
        active_id:this.activityId,
        content:this.berrageTxt
      }
      let res= await ajaxActiveMsg(params)
      let {code,prize,msg, data }=res.data
      if(code!=0){
       this.$layer.msg(msg) 
       return
      }

      let {member_head, member_name, am_content }=data
      let item = {
        // "img": this.MemberInfo.avatar,
        // "name": this.nick,
        // "info": this.berrageTxt,
        "img": member_head,
        "name": member_name,
        "info": am_content,
      }
      this.berrageTxt = ''
      this.$refs['danmaku'].add(item)
      
      // 奖品判断
      this.barragePrize=prize
      if(this.barragePrize<13){//红包奖品 or 积分奖品
        this.showPrizeDialog()
      }else{//福标签
        this.showBlessingDialog()
      }

    },
    randomInt(num1,num2){//生成[num1,num2]随机整数
      let num=Math.floor(Math.random() * num2) + num1
      return num
    },
    showLogin() {
      this.$layer.msg('请先登录');
      this.$login.show();
    },
    addZero(num_) {
      return Number(num_) < 10 ? `0${num_}` : num_
    },
  }
}
</script>
<style src="@/assets/css/activity/wickedcss.css"></style>
<style lang="scss" scoped>
 .module-hd{
    width: calc(100% - 30px);
    position: relative;
    margin: 0 auto;
    z-index: 9;
    .module-title{
      width: 100%;
      margin-bottom: 20px;
      img{
          width: 570px;
          display: block;
          margin: 0 auto;
      }
    }
    .mhd-content{
      width: 100%;
      position: relative;
      .item-image{
          width: 100%;
          display: block;
      }
      .mhd-page{
          width: 100%;
          position: absolute;
          top: 0;
          left: 0;
      }
    }
    &:not(:last-child){ margin-bottom: 50px; }
    &.moduleHd_08{
        // z-index: 10!important;
        .mhd-content{
            .mhd-page{
                .berrage-box{
                    padding: 89px 65px 0px;
                    .berrage-intro{
                      height: 118px;
                      padding: 0 30px;
                      color: #fceee0;
                      font-size: 20px;
                    }
                    .berrage-list{
                        // width: calc(100% - 10px);
                        height: 526px;
                        margin-top: 10px;
                        padding: 20px 0;
                        background: url("~@/assets/images/activity/barrage/mhd6-item.png") 50% 50%/100% 100% no-repeat;
                        ::v-deep .vue-danmaku{
                            width: 100%;
                            height: 100%;
                            .dm{
                                //width: auto!important;
                            }
                        }
                        .berrage-item{
                            // min-width: 320px;
                            // height: 50px;
                            // line-height: 40px;
                            line-height: 32px;
                            padding: 5px 20px 5px 5px;
                            font-size: 20px;
                            box-shadow: 0px -2px 15px 0px rgba(87, 30, 23, 0.4);
                            border-radius: 35px;
                            box-sizing: border-box;
                            z-index: 99;
                            cursor: default;
                            align-items: flex-start;
                            .name{
                                // max-width: 80px;
                                max-width: 4em;
                            }
                            .avatar{
                              width: 40px;
                              height: 40px;
                              margin-right: 10px;
                              border-radius: 50%;
                              &.ml{
                                margin-left: 5px;
                              }
                            }
                            .txt{
                              //  max-width: 20em;
                              white-space: normal;
                              min-height: 40px;
                            }
                            .txt1{
                                // margin: 0 10px;
                                // color: #fff;
                            }
                            .like{
                              cursor: pointer;
                            }
                            &.berrage-item1{
                              color: #ffe6c6;
                              background-color: #a6362c;
                            }
                            &.berrage-item2{
                              color: #a6362c;
                              background-color: #ffe6c6;
                            }
                        }
                    }
                    .berrage-action{
                      height: 96px;
                      margin-top: 10px;
                      .berrage-input{
                          height: 50px;
                          padding: 0 20px;
                          font-size: 20px;
                          color: #ffe6c6;
                          // background: #5A1510;
                          // border-radius: 6px;
                          background: url("~@/assets/images/activity/barrage/mhd6-input.png") 50% 50%/100% 100% no-repeat;
                          &::placeholder {
                            color: rgba(255, 204, 153, 0.3);
                          }
                      }
                      .berrage-send-btn{
                        position: relative;
                        margin-left: 30px;
                        cursor: pointer;
                        img{
                          display: block;
                          width: 148px;
                          &:nth-child(2){
                            position: absolute;
                            inset:0;
                            opacity: 0;
                          }
                        }
                        &:hover{
                          img{
                            &:nth-child(2){
                              opacity: 1;
                            }
                          }
                        }
                      }
                    }
                }
            }
        }
    }
}

.custom-dialog{
  background: none;
  box-shadow:none;
  overflow:visible;
  will-change: transform;
  backface-visibility: hidden;
}
.barrage-prize{
  .barrage_prizeItem1 {
      width: 600px;
      height: 100%;
      position: relative;
      margin: 0 auto;
      .barrage_close {
          width: 38px;
          height: 38px;
          background: url("~@/assets/images/activity/barrage/layer_close.png") no-repeat;
          background-size: 100% 100%;
          border-radius: 50%;
          position: absolute;
          bottom: -54px;
          left: 50%;
          transform: translate(-50%, 0);
          cursor: pointer;
      }
      >img {
          width: 100%;
          height: 100%;
          display: block;
      }
      .barrage_prize_button {
          width: 144px;
          height: 144px;
          background: url("~@/assets/images/activity/barrage/barrage_prize_an.png") no-repeat;
          background-size: 100% 100%;
          border-radius: 50%;
          position: absolute;
          bottom: 82px;
          left: calc(50% + 8px);
          transform: translate(-50%, 0);
          box-shadow: inset 0px 2px 0px 0px #ffef68;
          transition: all ease 0.2s;
          &:hover {
              background: url("~@/assets/images/activity/barrage/barrage_prize_an_on.png") no-repeat;
              background-size: 100% 100%;
          }
      }
  }
  .barrage_prizeItem2 {
      width: 600px;
      position: absolute;
      top: 50%;
      left: 50%;
      margin-top: -170px;
      margin-left:-300px;
      opacity: 0;
      z-index: -1;
      .barrage_close_btn{
        width: 38px;
        height: 38px;
        background: url("~@/assets/images/activity/barrage/layer_close.png") no-repeat;
        background-size: 100% 100%;
        position: absolute;
        bottom: -60px;
        left: 0;
        right: 0;
        margin: 0 auto;
        cursor: pointer;
      }
      >img {
          width: 100%;
          height: 100%;
          display: block;
      }
      .barrage_close_an{
        width: 208px;
        height: 58px;
        background: url("~@/assets/images/activity/barrage/prize_an.png") no-repeat;
        background-size: 100% 100%;
        border-radius: 25px;
        box-shadow: 0px 5px 5px 0px rgba(110, 0, 11, 0.65);
        position: absolute;
        left: 50%;
        bottom: 55px;
        margin-left: -104px;
        transition: all ease 0.2s;
        &:hover{
          background-image: url("~@/assets/images/activity/barrage/prize_an_on.png");
        }
      }
      &.zoomer {
          opacity: 1;
          z-index: 9;
      }
  }
}

.blessing-prize {
    width: 496px !important;
    // height: 470px !important;
    background: transparent !important;
    border: 0 !important;
    box-sizing: border-box;
    box-shadow: none !important;
    .blessing_img {
        width: 100%;
        height: 100%;
        display: block;
    }
    .blessing_button {
        width: 208px;
        height: 58px;
        background: url("~@/assets/images/activity/barrage/prize_an.png") no-repeat;
        background-size: 100% 100%;
        border-radius: 25px;
        box-shadow: 0px 5px 5px 0px rgba(110, 0, 11, 0.65);
        position: absolute;
        bottom: 66px;
        left: 50%;
        margin-left: -104px;
        transition: all ease 0.2s;
        &:hover{
          background-image: url("~@/assets/images/activity/barrage/prize_an_on.png");
        }
    }
    .blessing_close {
        width: 38px;
        height: 38px;
        background: url("~@/assets/images/activity/barrage/layer_close.png") no-repeat;
        background-size: 100% 100%;
        border-radius: 50%;
        position: absolute;
        bottom: -56px;
        left: 50%;
        transform: translate(-50%, 0);
        cursor: pointer;
    }
}

#sketchWrap{
  position: fixed;
  inset:0;
  z-index: 1000;
  pointer-events: none;
}
</style>
